<template>
  <v-app v-if="landerRoutes.includes(this.$route.name)">
    <router-view/>
  </v-app>
  <v-layout v-else>
    <navigation v-if="isAuthenticated && programsReady" />
    <top-bar v-if="isAuthenticated && programsReady"/>
    <v-main>
      <v-sheet id="app-content">
        <div v-if="programsBlocked" class="programs-gate d-flex align-center justify-center">
          <div v-if="programsFailed" class="text-center">
            <v-icon size="48" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
            <p class="text-body-1 mb-4">{{ $t('common.errors.programs_load_failed') }}</p>
            <v-btn color="primary" variant="elevated" @click="loadPrograms">
              {{ $t('common.actions.retry') }}
            </v-btn>
          </div>
          <loading-state
            v-else
            :title="$t('common.labels.setting_the_stage')"
            :subtitle="$t('common.labels.loading_your_program')"
          />
        </div>
        <router-view v-else />
      </v-sheet>
    </v-main>
    <v-snackbar variant="elevated" v-model="snackbar.show" :color="snackbar.type" :timeout="snackbar.timeout">
      {{ snackbar.text}}
      <template v-slot:actions="{ props }">
        <v-btn variant="text" v-bind="props" @click="snackbar.show=false">
          {{ $t('common.actions.close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <upload-indicator></upload-indicator>
    <download-dialog />
    <premium-dialog></premium-dialog>
    <contact-sales-bottom-sheet></contact-sales-bottom-sheet>
    <platform-requirements-bottom-sheet></platform-requirements-bottom-sheet>
  </v-layout>
</template>

<script>
import LoadingState from "@/components/LoadingState.vue";
import Navigation from "@/components/Navigation.vue";
import TopBar from "@/components/TopBar.vue";
import UploadIndicator from "@/components/UploadIndicator.vue";
import PremiumDialog from "@/components/dialog/PremiumDialog.vue";
import ContactSalesBottomSheet from "@/components/bottom-sheet/ContactSalesBottomSheet.vue";
import PlatformRequirementsBottomSheet from "@/components/bottom-sheet/PlatformRequirementsBottomSheet.vue";
import DownloadDialog from "@/components/dialog/DownloadDialog.vue";

export default {
  name: 'App',
  components: {
    LoadingState,
    DownloadDialog,
    PlatformRequirementsBottomSheet,
    ContactSalesBottomSheet,
    PremiumDialog,
    UploadIndicator,
    TopBar,
    Navigation,
  },
  data() {
    return {
      drawer: null,
      landerRoutes: [
        'login', 'register', 'lander', 'request-password-reset', 'confirm-password-reset',
        'demo', 'certificates', 'verify-email', 'video-embed',
      ],
    };
  },
  watch: {
    isAuthenticated: {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch('notifications/getNotifications');
          this.$store.dispatch('programs/loadPrograms');
          this.$store.dispatch('users/startAuthPolling');
        }
      },
    },
    selectedProgram(newVal) {
      if (!newVal) {
        return;
      }

      let currentUser = this.$store.getters['users/currentUser'];
      if (!currentUser) {
        return;
      }

      this.$store.dispatch('users/getUserProgress', {
        programId: newVal.id,
        userId: currentUser._id,
      });

      this.$store.dispatch('users/saveUserProfile', {
        ...currentUser,
        selected_program: newVal._id,
      });
    },
  },
  methods: {
    loadPrograms() {
      return this.$store.dispatch('programs/loadPrograms');
    },
  },
  computed: {
    programsReady() {
      return this.$store.getters['programs/programsReady'];
    },
    programsFailed() {
      return this.$store.getters['programs/programsFailed'];
    },
    programsBlocked() {
      return this.isAuthenticated && !this.programsReady;
    },
    selectedProgram() {
      return this.$store.getters['programs/selectedProgram'];
    },
    isAuthenticated() {
      return this.$store.getters['users/isAuth'];
    },
    snackbar: {
      get() {
        return this.$store.getters['userInterface/getSnackbar'];
      },
      set(value) {
        this.$store.dispatch('userInterface/snackBar', value);
      },
    },
  },
}
</script>

<style scoped>
.programs-gate {
  position: relative;
  min-height: calc(100dvh - var(--v-layout-top, 0px) - var(--v-layout-bottom, 0px));
  padding: 16px;
}

</style>
